module.exports = __webpack_public_path__ + "static/media/as_item1_price1.58c99642.png";